/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import Select, { components } from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import utils from '../../../../lib/utils';
import closeIcon from '../../../../assets/images/x_icon_black.svg';

import './index.scss';

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <i className="material-icons custom">arrow_drop_down</i>
      </components.DropdownIndicator>
    )
  );
};

const dropdownCustomStyle = {
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    // This line disable the blue border
    padding: '6px',
    boxShadow: 'none',
    outLine: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
  }),
};

const multiSelectdropdownCustomStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#007bff' : 'white',
    padding: '10px',
    color: state.isSelected ? 'white' : 'black',
    ':hover': {
      backgroundColor: '#f0f0f0', // Change the background color on hover
    },
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #CFD0D1',
    // This line disable the blue border
    padding: '6px',
    boxShadow: 'none',
    outLine: 'none',
    '&:hover': {
      border: '1px solid #CFD0D1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
  }),
};

const CustomOption = ({ innerProps, label, isSelected }) => {
  console.log('isSelected', isSelected);
  return (
    <div {...innerProps} className="custom-input-option">
      <input
        className="custom-input-select"
        type="checkbox"
        checked={isSelected}
        readOnly
      />
      <span className="custom-input-option_lable">{label}</span>
    </div>
  );
};

const validateName = function(str) {
  const regex = /^[a-zA-Z0-9 ,&-_]{1,100}$/;
  const valstr = regex.test(str) && str.trim() !== '' ? str : '';
  console.log('Validate', str, str.trim(), valstr, regex.test(str));
  return valstr;
};

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      copied: false,
      bookableViaTL: false,
      selectedProcedureCodes: [],
      durationDropdown: this.getDurationRange(),
      selectedDuration: '5',
      name: '',
      selectedType: 'SYNC_SERVICE',
      blockType: 'NONE',
      friendlyName: '',
      friendlyDescription: '',
      dirty: false,
      isActive: false
    };
  }

  componentDidMount() {
    const {
      selectedService,
      selectedServiceDetails,
      schedules,
      business,
      auth,
      serviceMappings,
    } = this.props;
    if (!utils.isEmptyObject(selectedService)) {
      const { name, duration, steps } = selectedService;
      const appointment_descriptor_ids = steps.map((stp) => stp.id);
      const selectedProcedureIdsForDA = serviceMappings[selectedService.id] || [];
      const selectedProcedureCodesForDA = schedules.procedure_codes.filter((procedure) =>
        selectedProcedureIdsForDA.includes(procedure?.id?.toString()),
      );
      const selectedProcedureCodes = auth.booking_software == 'DENTRIX_ASCEND' ?  selectedProcedureCodesForDA : schedules.procedure_codes.filter(
        (procedure) => appointment_descriptor_ids.includes(procedure.id),
      );
      console.log(
        'selectedService',
        selectedService,
        moment.duration(duration).asMinutes(),
        selectedProcedureCodes,
      );
      this.setState({
        name,
        selectedDuration: moment.duration(duration).asMinutes(),
        selectedProcedureCodes,
        selectedType:
          selectedServiceDetails?.block_type === 'DUMMY_BLOCKED'
            ? 'DUMMY_SERVICE'
            : 'SYNC_SERVICE',
        blockType:
          selectedServiceDetails?.block_type === 'DUMMY_BLOCKED'
            ? 'DUMMY_BLOCKED'
            : selectedServiceDetails?.block_type || 'NONE',
        friendlyName: selectedServiceDetails?.friendly_name || '',
        friendlyDescription: selectedServiceDetails?.friendly_description || '',
      });
    } else {
      const {
        name,
        selectedDuration,
        selectedProcedureCodes,
        selectedType,
        blockType,
        friendlyName,
        friendlyDescription,
      } = this.props;
      this.setState({
        name,
        selectedDuration,
        selectedProcedureCodes,
        selectedType: selectedType || 'SYNC_SERVICE',
        blockType: blockType || 'NONE',
        friendlyName,
        friendlyDescription,
      });
    }
  }
  changeBookiableViaTL = () => {
    const { bookableViaTL } = this.state;
    this.setState({
      bookableViaTL: !bookableViaTL,
      dirty: true,
    });
  };

  onSelect = (selectedList) => {
    const selectedValue = selectedList ? selectedList : [];
    this.setState({
      selectedProcedureCodes: selectedValue,
      dirty: true,
    });
    this.props.handleChangeInForm({
      target: {
        name: 'selectedProcedureCodes',
        value: selectedValue,
      },
    });
  };

  onRemove = (selectedList) => {
    this.setState({
      selectedProcedureCodes: selectedList,
      dirty: true,
    });
    this.props.handleChangeInForm({
      target: {
        name: 'selectedProcedureCodes',
        value: selectedList,
      },
    });
  };
  getDurationRange = () => {
    let duration = [];
    let durationMinutes = 240;
    let durationStep = 5;
    let durationStart = 0;
    while (durationMinutes > durationStart) {
      durationStart += durationStep;
      duration.push({ label: durationStart + ' min', value: durationStart });
    }
    return duration;
  };
  selectDuration = (event) => {
    this.setState({
      selectedDuration: event.value,
      dirty: true,
    });
    this.props.handleChangeInForm({
      target: {
        name: 'selectedDuration',
        value: event.value,
      },
    });
  };

  setBlockedToggle = (isBlocked) => {
    this.setState({
      blockType: isBlocked ? 'SYNCED_BLOCKED' : 'NONE',
      dirty: true,
    });
  };

  hasServiceAgentMetadataChange = (isAddMode) => {
    const {
      selectedType,
      blockType,
      friendlyName,
      friendlyDescription,
    } = this.state;
    const { selectedServiceDetails, selectedService } = this.props;

    if (selectedType === 'DUMMY_SERVICE') {
      return true;
    }

    const currentFriendlyName = (friendlyName || '').trim();
    const currentFriendlyDescription = (friendlyDescription || '').trim();
    const currentBlockType = blockType || 'NONE';

    if (isAddMode) {
      return (
        currentFriendlyName !== '' ||
        currentFriendlyDescription !== '' ||
        currentBlockType !== 'NONE'
      );
    }

    const previousFriendlyName =
      (selectedServiceDetails?.friendly_name ||
        selectedService?.friendly_name ||
        '') + '';
    const previousFriendlyDescription =
      (selectedServiceDetails?.friendly_description ||
        selectedService?.friendly_description ||
        '') + '';
    const previousBlockType =
      selectedServiceDetails?.block_type || selectedService?.block_type || 'NONE';

    return (
      currentFriendlyName !== previousFriendlyName.trim() ||
      currentFriendlyDescription !== previousFriendlyDescription.trim() ||
      currentBlockType !== previousBlockType
    );
  };

  addServiceType = () => {
    const {
      name,
      selectedDuration,
      selectedProcedureCodes,
      selectedType,
      blockType,
      friendlyName,
      friendlyDescription,
    } = this.state;
    const {
      business,
      selectedService,
      selectedServiceDetails,
      serviceMappings,
      updateServiceMapping,
      auth,
      closeServiceModal,
      isCSLogin,
    } = this.props;
    console.log(
      'name',
      selectedDuration,
      name,
      selectedProcedureCodes.map((proc) => proc.code),
    );
    const bzid = business?.id || auth?.studio_id;
    const data = {
      location_id: business?.details?.locations[0]?.id,
      business_id: bzid,
      service_id: utils.isEmptyObject(selectedService) ? '' : selectedService.id,
      service: selectedService,
      body: {
        name: name,
        minutes: selectedDuration,
        steps: selectedProcedureCodes,
      },
    };

    if (utils.isEmptyObject(selectedService)) {
      if (selectedType === 'DUMMY_SERVICE') {
        const dummyServicePayload = {
          category_id: `NX-${bzid}-P-1`,
          category_name: '',
          service_id: `NX-${bzid}-ST-FWD`,
          friendly_name: friendlyName,
          friendly_description: friendlyDescription,
          kind: 'SESSION',
          block_type: 'DUMMY_BLOCKED',
          manual_block: true,
        };
        this.props.addServiceTypes({
          ...data,
          serviceAgentBody: {
            business_id: bzid,
            updated_by: business?.clientUser?.email,
            services: [dummyServicePayload],
          },
        });
      } else {
        const shouldCallServiceAgentApi =
          isCSLogin && this.hasServiceAgentMetadataChange(true);
        if (shouldCallServiceAgentApi) {
          const syncedServiceAgentTemplate = {
            business_id: bzid,
            updated_by: business?.clientUser?.email,
            category_id: '',
            category_name: '',
            service_id: '',
            friendly_name: friendlyName,
            friendly_description: friendlyDescription,
            kind: 'SESSION',
            block_type: blockType,
            manual_block: blockType !== 'NONE',
          };
          this.props.addServiceTypes({
            ...data,
            serviceAgentBodyTemplate: syncedServiceAgentTemplate,
          });
        } else {
          this.props.addServiceTypes(data);
        }
      }
    } else {
      if (auth.booking_software == 'DENTRIX_ASCEND') {
        serviceMappings[selectedService.id] = selectedProcedureCodes.map((pc) =>
          pc?.id?.toString(),
        );
        updateServiceMapping(serviceMappings);
      }
      const effectiveBlockType =
        selectedType === 'DUMMY_SERVICE' ? 'DUMMY_BLOCKED' : blockType;
      const shouldCallServiceAgentApi =
        isCSLogin && this.hasServiceAgentMetadataChange(false);
      if (shouldCallServiceAgentApi) {
        const serviceAgentPayload = {
          category_id:
            selectedServiceDetails?.category_id ||
            selectedService?.category_id ||
            '',
          category_name:
            selectedServiceDetails?.category_name ||
            selectedService?.category_name ||
            '',
          service_id:
            selectedServiceDetails?.service_id ||
            selectedService?.service_id ||
            selectedService.id,
          friendly_name: friendlyName,
          friendly_description: friendlyDescription,
          kind: selectedServiceDetails?.kind || selectedService?.kind || 'SESSION',
          block_type: effectiveBlockType,
          manual_block:
            effectiveBlockType !== 'NONE' ? true :
            selectedServiceDetails?.manual_block ??
            selectedService?.manual_block ??
            false,
        };
        this.props.editServiceTypes({
          ...data,
          body: {
            business_id: bzid,
            updated_by: business.clientUser.email,
            services: [serviceAgentPayload],
          },
        });
      } else {
        this.props.editServiceTypes(data);
      }
    }
    this.setState({
      dirty: false,
    });
    closeServiceModal();
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: validateName(event.target.value),
      dirty: true,
    });

    this.props.handleChangeInForm({
      target: {
        name: event.target.name,
        value: validateName(event.target.value),
      },
    });
  };

  handleFriendlyFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      dirty: true,
    });
  };
  isDisabled = () => {
    const { name, dirty, selectedType } = this.state;
    const { schedules } = this.props;
    const isNameRequired = selectedType !== 'DUMMY_SERVICE';
    if (
      (isNameRequired && name?.length < 1) ||
      schedules.addServiceType ||
      schedules.editServiceType ||
      !dirty
    ) {
      return true;
    }
    return false;
  };
  render() {
    const {
      modelopen,
      closeServiceModal,
      schedules,
      selectedService,
      auth,
      isCSLogin,
    } = this.props;
    const {
      durationDropdown,
      dirty,
      selectedProcedureCodes,
      selectedType,
      blockType,
      friendlyName,
      friendlyDescription,
    } = this.state;
    const isAddMode = utils.isEmptyObject(selectedService);
    const isBlocked = blockType !== 'NONE';
    console.log('procedure_codes', selectedProcedureCodes, schedules.procedure_codes);
    const prefix = utils.isEmptyObject(selectedService) ? 'Add' : 'Edit';
    const buttonName = utils.isEmptyObject(selectedService) ? 'ADD' : 'UPDATE';
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">{prefix} Service Type</div>
              <button className="modal-close" onClick={closeServiceModal}>
                <img src={closeIcon}></img>
              </button>
              {selectedType !== 'DUMMY_SERVICE' && (
                <div className="input">
                  <label className="label">Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder={'Enter name for the service'}
                    value={this.state.name}
                    onChange={this.handleChange}
                    disabled={auth.booking_software == 'DENTRIX_ASCEND'}
                    maxlength="100"
                  />
                </div>
              )}
              {selectedType !== 'DUMMY_SERVICE' && (
                <>
                  <div className="input">
                    <label className="label">Procedure code(s)</label>
                    <Select
                      defaultValue={[]}
                      value={selectedProcedureCodes}
                      getOptionLabel={(option) => option?.code + " - " + option?.name}
                      getOptionValue={(option) => option?.id?.toString()}
                      options={schedules.procedure_codes}
                      onChange={this.onSelect}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option: CustomOption,
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                      }}
                      maxMenuHeight={180}
                      styles={multiSelectdropdownCustomStyle}
                    />
                  </div>
                  <div className="input">
                    <label className="label">Duration</label>
                    <Select
                      components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                      }}
                      value={durationDropdown.filter(
                        (c) => c.value === this.state.selectedDuration,
                      )}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      options={durationDropdown}
                      onChange={this.selectDuration}
                      styles={dropdownCustomStyle}
                      isDisabled={auth.booking_software === 'DENTRIX_ASCEND'}
                    />
                  </div>
                </>
              )}
              {isCSLogin && (
                <div className="input">
                  <label className="label">Friendly name</label>
                  <input
                    type="text"
                    name="friendlyName"
                    placeholder={'Enter friendly name'}
                    value={friendlyName}
                    onChange={this.handleFriendlyFieldChange}
                    maxlength="200"
                  />
                </div>
              )}
              {isCSLogin && (
                <div className="input">
                  <label className="label">Description</label>
                  <textarea
                    name="friendlyDescription"
                    placeholder={'Enter description'}
                    value={friendlyDescription}
                    onChange={this.handleFriendlyFieldChange}
                    rows="4"
                    maxlength="1000"
                  />
                </div>
              )}
              {isCSLogin && selectedType !== 'DUMMY_SERVICE' && (
                <div className="input">
                  <label className="label">Blocked</label>
                  <ToggleSwitch
                    checked={isBlocked}
                    onChange={() => this.setBlockedToggle(!isBlocked)}
                  />
                </div>
              )}
              {!dirty && (
                <div className="error-message">{schedules.errorMessage}</div>
              )}
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.addServiceType}
                  disabled={this.isDisabled()}
                >
                  {schedules.addServiceType ? buttonName + 'ING..' : buttonName}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeServiceModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
